module.exports = __webpack_public_path__ + "img/logo_nyyh.fb7fefad.png";